export default __webpack_public_path__ + "static/media/chart-take-away.b7693fe3.svg";